// extracted by mini-css-extract-plugin
export default {"buttonStyle":"styles_buttonStyle__LLNsu","imgStyle":"styles_imgStyle__74Z6W"};